import { useMutation, UseMutationResult, useQuery, UseQueryResult } from "react-query";
import { ApiGetDataOptions, ApiPostDataOptions, ApiUrlType } from "./type";
import clientWrapper, { clientMutateWrapper, clientPostWrapper } from "../datasource/apiClientWrapper";
import { ApiClientInput } from "../datasource/type";
import { HttpVerb } from "../utils/enums";

export function getApiQueryKey(apiUrl: ApiUrlType, params?: ApiClientInput) {
  return [apiUrl, ...Object.values({ ...(params?.params || {}), ...(params?.pathParams || {}) }).sort()];
}

export function useGetApiData<T>(
  apiUrl: ApiUrlType,
  params?: ApiClientInput,
  options?: ApiGetDataOptions<T>
): UseQueryResult<T> {
  return useQuery(options?.queryKey || getApiQueryKey(apiUrl, params), clientWrapper(apiUrl as string, params), {
    enabled: options?.enabled,
    keepPreviousData: options?.keepPreviousData,
    staleTime: options?.staleTime,
    onError: options?.onError,
    onSuccess: options?.onSuccess,
    refetchInterval: options?.refetchInterval,
    meta: { noLoader: options?.hideLoader },
    cacheTime: options?.cacheTime,
    initialData: options?.initialData,
    select: options?.select
  });
}

export function usePostApiData<ResponseType, RequestType = ResponseType>(
  apiUrl: ApiUrlType,
  options?: ApiPostDataOptions<ResponseType>
): UseMutationResult<ResponseType, any, RequestType, any> {
  return useMutation<ResponseType, any, RequestType, any>(
    clientPostWrapper<ResponseType, RequestType>(apiUrl, options?.clientOptions),
    {
      onError: options?.onError,
      onSuccess: options?.onSuccess,
      meta: { noLoader: options?.hideLoader }
    }
  );
}

export function useGetApiDataAsMutate<ResponseType>(
  apiUrl: ApiUrlType,
  options?: ApiPostDataOptions<ResponseType>
): UseMutationResult<ResponseType, any, ApiClientInput> {
  return useMutation<ResponseType, any, ApiClientInput>(clientMutateWrapper<ResponseType>(apiUrl, HttpVerb.GET), {
    onError: options?.onError,
    onSuccess: options?.onSuccess,
    meta: { noLoader: options?.hideLoader }
  });
}

export function useDeleteApiData<ResponseType = any>(
  apiUrl: ApiUrlType,
  options?: ApiPostDataOptions<ResponseType>
): UseMutationResult<ResponseType, any, ApiClientInput> {
  return useMutation<ResponseType, any, ApiClientInput>(clientMutateWrapper<ResponseType>(apiUrl, HttpVerb.DELETE), {
    onError: options?.onError,
    onSuccess: options?.onSuccess,
    meta: { noLoader: options?.hideLoader }
  });
}
